import { mpsEndpoints } from '../mps/mps-endpoints';

export const environment = {
  production: false,
  envName: 'dev',
  api: {
    host: 'https://api-chargeplus-web-d.totalservicesd.alzp.tgscloud.net',
    providers: mpsEndpoints.providers,
  },
  loaderOnHttp: true,
  defaultLocale: 'fr_FR',
  allowedLanguage: ['fr_FR', 'en_FR'],
  servedLocales: ['fr_FR', 'en_FR', 'es_ES', 'en_ES', 'eu_ES', 'ca', 'fr_BE', 'nl_BE', 'en_BE'],
  lokaliseProjectId: '884847186924a4cde1bff9.92359623',
  appName: 'BackOffice Charge+',
  mpsIcons: ['bin', 'edit', 'gray-edit', 'user', 'info', 'pdf', 'pdf-file', 'three-dots', 'account-circle', 'search'],
  appIcons: [],
  translationsSource: 'server',
  allowImpersonation: false,
};
